// extracted by mini-css-extract-plugin
module.exports = {"optionEdit":"optionEdit-2s3vB","disabled":"disabled-15XvJ"};